angular.module( 'acme.view.application.themes.donation.modals.editValue', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.themes.donation.modals.editValue.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var themesDonationModalsEditValue = {
        name: 'application.themes.donation.modals.editValue',
        url: '/themes/donation/modals/editValue',
        views: {
          "main": {
            controller: 'ThemesDonationModalsEditValueController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/themes/donation/modals/editValue/editValue.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(themesDonationModalsEditValue);
});
